<template>
  <div class="app">
    <div class="page-loader" v-if="pageLoader">
      <div class="page-spinner"><i class="fa fa-spinner fa-spin"></i></div>
    </div>
    <AppHeader/>
    <div class="app-body">
      <Sidebar :navItems="nav"/>
      <main class="main">
        <breadcrumb :list="list"/>
        <div class="container-fluid">
          <router-view></router-view>
        </div>
      </main>
      <AppAside/>
    </div>
    <AppFooter/>
  </div>
</template>

<script>
import VueNotifications from 'vue-notifications'
import {Events} from '../events.js'
import nav from '../_nav'
import { Header as AppHeader, Sidebar, Aside as AppAside, Footer as AppFooter, Breadcrumb } from '../components/'

export default {
  name: 'full',
  components: {
    AppHeader,
    Sidebar,
    AppAside,
    AppFooter,
    Breadcrumb
  },
  data () {
    return {
      nav: nav.items,
      pageLoader: false
    }
  },
  notifications: {
    showMsg: {
      type: VueNotifications.types.success,
      title: '',
      message: '',
      timeout: 1500
    }
  },
  methods: {
    onPageLoader () {
      this.pageLoader = !this.pageLoader
    },
    onAlert (type, title, msg) {
      this.showMsg({
        type: type,
        title: title,
        message: msg
      })
    }
  },
  computed: {
    name () {
      return this.$route.name
    },
    list () {
      return this.$route.matched
    }
  },
  created () {
    Events.$on('alert', this.onAlert)
    Events.$on('loader', this.onPageLoader)
  }
}
</script>

<style lang="scss" scoped>
  .page-loader {
    position: fixed;
    z-index: 10000;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    background-color: rgba(0, 0, 0, 0.45);
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .page-loader .page-spinner i {
    font-size: 3em
  }
</style>


// WEBPACK FOOTER //
// src/containers/Full.vue